export default __webpack_public_path__ + "static/media/roadster.d229fae8.png";